import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=41f26586&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=41f26586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f26586",
  null
  
)

export default component.exports